import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import "./Button.css";

const Button = props => (
  <span>
    {props.linkPath ? (
      <Link to={props.linkPath} className="btn btn-dark">
        {props.children}
      </Link>
    ) : (
      <button className="btn btn-dark">{props.children}</button>
    )}
  </span>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  linkPath: PropTypes.string,
};

Button.defaultProps = {
  linkPath: null,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js